import React, { Component } from 'react'
import { Form } from 'semantic-ui-react'

export default function Textarea({ inputLabel, formState, referenceConfig, ...props }) {
  let classes = ['form-input', 'form-input--textarea']
  return <Form.TextArea {...props} autoHeight className={classes.join(' ')} />
}
